import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import { StartupContactModel } from 'app/models/contact-form/startup-contact.model';

@Component({
    selector: 'app-ssdf-call-dashboard-overview',
    templateUrl: './ssdf-call-dashboard-overview.component.html',
    styleUrls: ['./ssdf-call-dashboard-overview.component.scss']
})
export class SsdfCallDashboardOverviewComponent implements OnInit {
    @Input() generalData: any;
    @Input() appForDay: any;
    @Input() batchData: any;
    @Input() formedCompanyData: any;
    @Input() zoneData: any;
    @Input() labNeededData: any;
    @Input() patentsData: any;
    @Input() fundingNeedPieData: any;
    @Input() originationData: any;
    @Input() appForTrl: any;
    @Input() fundingNeedBarData: any;
    @Input() appForPremoney: any;
    @Input() appForRegion: any;
    @Input() countryData: any;

    @Input() applicationList: StartupContactModel[];
    appForDayNext = {
        labels: ['07/07/2023', '08/07/2023', '09/07/2023', '10/07/2023', '11/07/2023', '12/07/2023'],
        series: [12, 13, 15, 16, 25]
    }
    generalDataNext = {
        todayApplications: 10,
        totalApplications: 160,
        weekApplications: 44
    }

    constructor() {
    }

    ngOnInit(): void {

    }

    ngOnChanges(changes: SimpleChanges) {
        console.log(changes)
        if (changes && changes.generalData && changes.generalData.currentValue) {
            const totalNextApps = this.appForDayNext.series.reduce(
                (accumulator, currentValue) => accumulator + currentValue,
                0)
            this.generalDataNext = {
                totalApplications: changes.generalData.currentValue.totalApplications + totalNextApps,
                todayApplications: this.appForDayNext.series[0],
                weekApplications: totalNextApps
            }
        }
    }

}
